"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Controls = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _actions = _interopRequireDefault(require("@site/pattern-library-core/actions"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _actions2 = _interopRequireDefault(require("../../../../elements/other/actions"));
var _playButton = _interopRequireDefault(require("../../../../elements/buttons/play-button"));
var _base = require("@site/pattern-library-utils/base.functions");
const BannerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BannerContainer",
  class: "pl-b1tjaubq"
});
const Bar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Bar",
  class: "pl-b1uee7rn"
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentWrapper",
  class: "pl-c1rqsydh"
});
const PricingWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PricingWrapper",
  class: "pl-p33kxm1"
});
const Controls = exports.Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-c1s2bdbp"
});

/**
 * OfferBanner Component.
 *
 * @param {Object} props React props
 * @param {string} heading OfferBanner title
 * @param {string} tagLabel OfferBanner tag label
 * @param {string} labelDesign OfferBanner tag label design
 * @param {Object} priceLockup OfferBanner price lockup
 * @param {Object|Array} ctas OfferBanner call to actions
 * @param {Object} anchorButton OfferBanner anchor button
 * @param {string} playButtonText OfferBanner play button text
 * @param {string} ariaLabelPlayButtonText OfferBanner play button aria label text
 * @param {Function} openLightBox OfferBanner open lightbox function
 * @returns {React.ReactElement} OfferBanner Component
 * @public
 */
function OfferBanner({
  heading,
  tagLabel,
  labelDesign,
  priceLockup,
  ctas,
  anchorButton,
  playButtonText,
  ariaLabelPlayButtonText,
  openLightBox
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BannerContainer, {
    "data-cy": "offer-banner"
  }, /*#__PURE__*/_react.default.createElement(Bar, null, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    className: "offer-banner-tag",
    text: tagLabel,
    design: labelDesign,
    size: "sm"
  }), /*#__PURE__*/_react.default.createElement(_text.default.h4, {
    as: "title",
    className: "banner-headline",
    size: 2,
    text: heading
  }), anchorButton && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [{
      design: 'inline',
      size: 'small',
      ...anchorButton
    }]
  })), /*#__PURE__*/_react.default.createElement(PricingWrapper, null, priceLockup && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({
    align: "start"
  }, priceLockup)), ctas && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "ctas"
  }, Array.isArray(ctas) ? /*#__PURE__*/_react.default.createElement(_actions2.default, {
    actionsLayout: "button-set",
    ctas: ctas.map(cta => ({
      ...cta,
      shrinkOn: 'tablet'
    }))
  }) : ctas))), playButtonText && /*#__PURE__*/_react.default.createElement(Controls, null, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "lightbox-play-button",
    invert: true,
    handlePlay: openLightBox,
    size: "small",
    buttonText: playButtonText,
    ariaLabelButtonText: ariaLabelPlayButtonText
  }))));
}
var _default = exports.default = OfferBanner;
OfferBanner.propTypes = {
  heading: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  priceLockup: _propTypes.default.object,
  ctas: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
  anchorButton: _propTypes.default.object,
  playButtonText: _propTypes.default.string,
  ariaLabelPlayButtonText: _propTypes.default.string,
  openLightBox: _propTypes.default.func
};